import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";

export default function MainV2TopBanner(props: React.ComponentProps<typeof Root>) {
  return (
    <Root
      initial={false}
      animate={{
        translateY: 0,
        opacity: 1,
        marginBottom: 0,
      }}
      exit={{
        translateY: "-100%",
        opacity: 0,
        marginBottom: "-64px",
      }}
      {...props}
    />
  );
}

const Root = styled(motion.div)`
  background-color: black;
  background-size: 400% 400%;
  animation: gradient-button 10s infinite linear;
  color: white;
  padding: 12px 16px;
  gap: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  box-sizing: border-box;
  z-index: 1;

  svg {
    flex-shrink: 0;
  }
`;
